import React from 'react'
import './app.css'
import Navbar from './Components/Navbar/Navbar'
import Home from './Components/Home/Home'
import Middle from './Components/Middle/Middle'
import About from './Components/About/About'
import Destination from './Components/Destination/Destination.jsx'
import Popular from './Components/Popular/Popular.jsx'
import Testimonial from './Components/Testimonial/Testimonial.jsx'
import Contact from './Components/Contact/Contact.jsx'
import Footer from './Components/Footer/Footer.jsx'
import Fade from 'react-reveal/Fade';

const App = () => {
  return (
    <>
   
    <Navbar />
    <Home/>

    <Fade bottom duration={2000}>
    <About/>
    </Fade>

    <Fade bottom duration={2000}>
    <Popular/>
    <Middle/>
    </Fade>

   
    <Destination/>
  

    <Fade left duration={1500}>
    <Testimonial/>
    </Fade>
    
    <Fade right duration={1500}>
    <Contact/>
    </Fade>
    
    <Fade bottom duration={1500}>
    <Footer/>
    </Fade>
    
    </>
    
  )
}

export default App